import styled, { keyframes } from "styled-components";
import { CheckedIcon, ClearIcon } from "../../../Previews/Svg";
import LoadingIndicator from "react-loading-indicator";

export const changedAnimation = (backgroundColor) => keyframes`
  0% {
    background-color: transparent;
  }
  25% {
    background-color: ${backgroundColor};
    transform: scale(1.02);
  }
  100% {
    background-color: transparent;
  }
`;

export const ChannelDataWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: ${(props) => props.padding || "3px 6px"};
  border-radius: 6px;
  transition: all 0.2s;
  animation: "";
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  text-wrap: initial;
  font-size: 14px;

  ${(props) =>
    props.editable &&
    `
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: ${props.dark ? "#44424C" : "#f2f2f2"};
    };
  `}
  ${(props) =>
    props.ellipsis &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

export const ChannelDataLink = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
`;

export const ChannelDataEditorWrapper = styled.div`
  position: relative;
`;

export const Editor = styled.div`
  padding: 10px;
  color: black;
`;

export const ChannelDataInputWrapper = styled.div`
  position: relative;
`;

export const EditorActions = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translate(0, -50%);
`;

export const EditorInfo = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Rubik;
  font-size: 12px;
  margin-bottom: 4px;
`;

export const ChannelDataLabel = styled.label`
  font-weight: 500;
`;

export const ChannelDataError = styled.div`
  font-family: Rubik;
  font-size: 12px;
  min-height: 13px;
  color: #ff0202;
  font-weight: 500;
  transition: all 0.2s;
  ${(props) =>
    props.active
      ? `
    margin-bottom: 0;
    margin-top: 4px;
    opacity: 1;
    visibility: visible;
  `
      : `
    margin-bottom: -13px;
    margin-top: 0;
    opacity: 0;
    visibility: hidden;
  `};
`;

export const InputLimit = styled.div`
  font-weight: 400;
`;

export const ChannelDataInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #1e22ff;
  padding: 0 74px 0 6px;
  border-radius: 6px;
  background: #f9f8fb;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #302f38;
  transition: all 2s;
  &:focus,
  &:active {
    border: 1px solid #1e22ff;
  }
`;

export const Checked = styled(CheckedIcon)`
  display: flex;
  width: 20px;
  height: 20px;
`;

export const Clear = styled(ClearIcon)`
  display: flex;
  width: 20px;
  height: 20px;
`;

export const CheckedButtonWrapper = styled.div`
  margin-right: 4px;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translate(0, -50%);
  svg {
    width: 20px;
    height: 20px;
    color: rgb(76 79 84);
  }
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
`;

export const Loader = styled(LoadingIndicator)`
  display: flex;
`;
